// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wm-modal-release-update-app {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: var(--ion-background-color);
  position: relative;
}
.wm-modal-release-update-app .ios-filling {
  height: env(safe-area-inset-top);
  background: var(--ion-background-color);
}
.wm-modal-release-update-app .wm-modal-release-update-app-header {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px;
  min-height: 60px;
}
.wm-modal-release-update-app .wm-modal-release-update-app-header .wm-modal-release-update-app-closebtn {
  font-size: 28px;
  color: var(--ion-color-medium);
  cursor: pointer;
  z-index: 10;
}
.wm-modal-release-update-app .wm-modal-release-update-app-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 24px;
  text-align: center;
}
.wm-modal-release-update-app .wm-modal-release-update-app-content .wm-modal-release-update-app-icon {
  font-size: 80px;
  color: var(--ion-color-primary);
  margin-bottom: 24px;
}
.wm-modal-release-update-app .wm-modal-release-update-app-content .wm-modal-release-update-app-title {
  font-size: 24px;
  font-weight: bold;
  color: var(--ion-color-dark);
  margin-bottom: 16px;
  display: block;
}
.wm-modal-release-update-app .wm-modal-release-update-app-content .wm-modal-release-update-app-message {
  font-size: 16px;
  color: var(--ion-color-medium);
  margin-bottom: 16px;
  display: block;
  line-height: 1.5;
}
.wm-modal-release-update-app .wm-modal-release-update-app-content .wm-modal-release-update-app-version {
  font-size: 14px;
  color: var(--ion-color-primary);
  margin-bottom: 32px;
  display: block;
  font-weight: 500;
}
.wm-modal-release-update-app .wm-modal-release-update-app-content .wm-modal-release-update-app-buttoncontainer {
  width: 100%;
  max-width: 400px;
}
.wm-modal-release-update-app .wm-modal-release-update-app-content .wm-modal-release-update-app-buttoncontainer .wm-modal-release-update-app-button {
  margin-bottom: 12px;
  --border-radius: 8px;
  height: 48px;
  font-weight: 600;
}
.wm-modal-release-update-app .wm-modal-release-update-app-content .wm-modal-release-update-app-buttoncontainer .wm-modal-release-update-app-button-close {
  --border-radius: 8px;
  height: 48px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/modal-release-update/modal-release-update.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,uCAAA;EACA,kBAAA;AACF;AACE;EACE,gCAAA;EACA,uCAAA;AACJ;AAEE;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAAJ;AAEI;EACE,eAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;AAAN;AAIE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;AAFJ;AAII;EACE,eAAA;EACA,+BAAA;EACA,mBAAA;AAFN;AAKI;EACE,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,mBAAA;EACA,cAAA;AAHN;AAMI;EACE,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAJN;AAOI;EACE,eAAA;EACA,+BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AALN;AAQI;EACE,WAAA;EACA,gBAAA;AANN;AAQM;EACE,mBAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;AANR;AASM;EACE,oBAAA;EACA,YAAA;EACA,gBAAA;AAPR","sourcesContent":[".wm-modal-release-update-app {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  background: var(--ion-background-color);\n  position: relative;\n\n  .ios-filling {\n    height: env(safe-area-inset-top);\n    background: var(--ion-background-color);\n  }\n\n  .wm-modal-release-update-app-header {\n    position: relative;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    padding: 16px;\n    min-height: 60px;\n\n    .wm-modal-release-update-app-closebtn {\n      font-size: 28px;\n      color: var(--ion-color-medium);\n      cursor: pointer;\n      z-index: 10;\n    }\n  }\n\n  .wm-modal-release-update-app-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n    padding: 24px;\n    text-align: center;\n\n    .wm-modal-release-update-app-icon {\n      font-size: 80px;\n      color: var(--ion-color-primary);\n      margin-bottom: 24px;\n    }\n\n    .wm-modal-release-update-app-title {\n      font-size: 24px;\n      font-weight: bold;\n      color: var(--ion-color-dark);\n      margin-bottom: 16px;\n      display: block;\n    }\n\n    .wm-modal-release-update-app-message {\n      font-size: 16px;\n      color: var(--ion-color-medium);\n      margin-bottom: 16px;\n      display: block;\n      line-height: 1.5;\n    }\n\n    .wm-modal-release-update-app-version {\n      font-size: 14px;\n      color: var(--ion-color-primary);\n      margin-bottom: 32px;\n      display: block;\n      font-weight: 500;\n    }\n\n    .wm-modal-release-update-app-buttoncontainer {\n      width: 100%;\n      max-width: 400px;\n\n      .wm-modal-release-update-app-button {\n        margin-bottom: 12px;\n        --border-radius: 8px;\n        height: 48px;\n        font-weight: 600;\n      }\n\n      .wm-modal-release-update-app-button-close {\n        --border-radius: 8px;\n        height: 48px;\n        font-weight: 500;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
